// src/pages/Quotation/QuotationListPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import UserNavbar from "../../User/UserNavbar";
import UserFooter from "../../User/UserFooter";
import MainSidebar from "../../User/Mainsidebar";
import { listQuotations, deleteQuotation, generateInvoice } from "../../api/quotationApi";
import QuotationStatusBadge from "../../components/Quotation/QuotationStatusBadge";
import QuotationGenerateFromPOModal from "../../components/Quotation/QuotationGenerateFromPOModal";
import QuotationStatusModal from "../../components/Quotation/QuotationStatusModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const STATUSES = ["", "DRAFT", "SENT", "APPROVED", "REJECTED", "INVOICED"];
const STATUS_LABELS = { "": "All", DRAFT: "Draft", SENT: "Sent", APPROVED: "Approved", REJECTED: "Rejected", INVOICED: "Invoiced" };

const QuotationListPage = () => {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const [quotations, setQuotations]     = useState([]);
  const [loading, setLoading]           = useState(true);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchQuery, setSearchQuery]   = useState("");
  const [showGenModal, setShowGenModal] = useState(false);
  const [statusTarget, setStatusTarget] = useState(null);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const load = async (status = statusFilter) => {
    setLoading(true);
    try {
      const res = await listQuotations(status || null);
      if (res.ok) {
        const data = await res.json();
        setQuotations(Array.isArray(data) ? data : []);
      } else {
        setQuotations([]);
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to load quotations from server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [statusFilter]);

  const handleDelete = async (q) => {
    if (!window.confirm(`Delete quotation ${q.quoteNumber}? This cannot be undone.`)) return;
    try {
      const res = await deleteQuotation(q.id);
      if (res.ok) {
        toast.success("Quotation deleted successfully.");
        load();
      } else {
        const err = await res.json().catch(() => ({}));
        toast.error("Delete failed: " + (err.message || res.status));
      }
    } catch (e) {
      toast.error("Error deleting quotation.");
    }
  };

  const handleGenerateInvoice = async (q) => {
    if (!window.confirm(`Generate invoice from quotation ${q.quoteNumber}?`)) return;
    try {
      const res = await generateInvoice(q.id);
      if (res.ok) {
        toast.success("Invoice generated successfully!");
        load();
      } else {
        const err = await res.json().catch(() => ({}));
        toast.error("Failed: " + (err.message || res.status));
      }
    } catch (e) {
      toast.error("Error generating invoice.");
    }
  };

  const filteredQuotations = quotations.filter((q) => {
    if (!searchQuery) return true;
    const qNum = (q.quoteNumber || "").toLowerCase();
    const vName = (q.vendorName || "").toLowerCase();
    const query = searchQuery.toLowerCase();
    return qNum.includes(query) || vName.includes(query);
  });

  return (
    <>
      <div>
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            setisRightMenu={setisRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            isSearchShow={isSearchShow}
            setIsSearchShow={setIsSearchShow}
            handelShow={handelShow}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
          />
          <ToastContainer />
          <div className="content-wrapper pt-3">
            <section className="content">
              <div className="container-fluid">
                {/* Header Actions Card */}
                <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                      <div>
                        <h5 className="mb-1 fw-bold text-dark">All Quotations</h5>
                        <p className="text-muted small mb-0">
                          Create, track, and manage client quotations connected to backend ERP.
                        </p>
                      </div>
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => setShowGenModal(true)}
                          style={{ borderRadius: "8px", fontWeight: "600", fontSize: "0.88rem" }}
                        >
                          <i className="fas fa-file-import me-1" /> Generate from PO
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => navigate("/create-quotation")}
                          style={{
                            borderRadius: "8px",
                            fontWeight: "600",
                            fontSize: "0.88rem",
                            background: "#4f46e5",
                            borderColor: "#4f46e5",
                          }}
                        >
                          <i className="fas fa-plus me-1" /> Create Quotation
                        </button>
                      </div>
                    </div>

                    <hr className="my-3" />

                    {/* Filter and Search Bar */}
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                      <div className="d-flex gap-2 flex-wrap">
                        {STATUSES.map((s) => (
                          <button
                            key={s}
                            onClick={() => setStatusFilter(s)}
                            className="btn btn-sm"
                            style={{
                              borderRadius: "20px",
                              fontSize: "0.82rem",
                              padding: "4px 14px",
                              fontWeight: statusFilter === s ? "600" : "400",
                              background: statusFilter === s ? "#4f46e5" : "#f1f5f9",
                              color: statusFilter === s ? "#fff" : "#475569",
                              border: "none",
                            }}
                          >
                            {STATUS_LABELS[s]}
                          </button>
                        ))}
                      </div>
                      <div style={{ minWidth: "240px" }}>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-light border-end-0">
                            <i className="fas fa-search text-muted" />
                          </span>
                          <input
                            type="text"
                            className="form-control border-start-0"
                            placeholder="Search by quote # or vendor..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quotations Table Card */}
                <div className="card shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
                  <div className="card-body p-0">
                    {loading ? (
                      <div className="text-center py-5 text-muted">
                        <i className="fas fa-spinner fa-spin fa-2x mb-3 text-primary d-block" />
                        Loading quotations...
                      </div>
                    ) : filteredQuotations.length === 0 ? (
                      <div className="text-center py-5">
                        <div style={{ fontSize: "2.5rem" }} className="mb-2">📋</div>
                        <h6 className="fw-semibold text-secondary">No Quotations Found</h6>
                        <p className="text-muted small mb-3">
                          {statusFilter ? `No quotations in ${STATUS_LABELS[statusFilter]} status.` : "Start by creating a new quotation or generating from a Purchase Order."}
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => navigate("/create-quotation")}
                          style={{ borderRadius: "6px", background: "#4f46e5", borderColor: "#4f46e5" }}
                        >
                          <i className="fas fa-plus me-1" /> Create Quotation
                        </button>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.88rem" }}>
                          <thead className="table-light">
                            <tr>
                              <th style={{ padding: "12px 16px" }}>Quote Number</th>
                              <th>Date</th>
                              <th>Customer / Vendor</th>
                              <th>Total Amount</th>
                              <th>Status</th>
                              <th className="text-end" style={{ paddingRight: "20px" }}>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredQuotations.map((q) => (
                              <tr key={q.id}>
                                <td style={{ padding: "12px 16px" }}>
                                  <span
                                    className="fw-bold text-primary"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(`/quotations/${q.id}`)}
                                  >
                                    {q.quoteNumber}
                                  </span>
                                </td>
                                <td>{q.quoteDate || "—"}</td>
                                <td className="fw-medium">{q.vendorName || "—"}</td>
                                <td className="fw-semibold">
                                  ₹{Number(q.totalAmount ?? 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </td>
                                <td>
                                  <QuotationStatusBadge status={q.status} />
                                </td>
                                <td className="text-end" style={{ paddingRight: "20px" }}>
                                  <div className="d-flex gap-1 justify-content-end">
                                    <button
                                      className="btn btn-outline-primary btn-sm px-2 py-1"
                                      onClick={() => navigate(`/quotations/${q.id}`)}
                                      title="View Details"
                                    >
                                      <i className="fas fa-eye" />
                                    </button>
                                    {["DRAFT", "SENT"].includes(q.status) && (
                                      <button
                                        className="btn btn-outline-info btn-sm px-2 py-1"
                                        onClick={() => setStatusTarget(q)}
                                        title="Change Status"
                                      >
                                        <i className="fas fa-exchange-alt" />
                                      </button>
                                    )}
                                    {q.status === "APPROVED" && (
                                      <button
                                        className="btn btn-outline-success btn-sm px-2 py-1"
                                        onClick={() => handleGenerateInvoice(q)}
                                        title="Generate Invoice"
                                      >
                                        <i className="fas fa-file-invoice" />
                                      </button>
                                    )}
                                    {(q.status === "DRAFT" || q.status === "REJECTED") && (
                                      <button
                                        className="btn btn-outline-danger btn-sm px-2 py-1"
                                        onClick={() => handleDelete(q)}
                                        title="Delete Quotation"
                                      >
                                        <i className="fas fa-trash-alt" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
          <UserFooter />
        </div>
      </div>

      {showGenModal && (
        <QuotationGenerateFromPOModal
          onClose={() => setShowGenModal(false)}
          onSuccess={(newQuote) => {
            toast.success(`Quotation ${newQuote.quoteNumber} generated successfully!`);
            load();
            navigate(`/quotations/${newQuote.id}`);
          }}
        />
      )}

      {statusTarget && (
        <QuotationStatusModal
          quotation={statusTarget}
          onClose={() => setStatusTarget(null)}
          onSuccess={() => {
            toast.success("Quotation status updated.");
            load();
          }}
        />
      )}
    </>
  );
};

export default QuotationListPage;
